import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import type { FieldValidationError } from './parseValidationDetail';

/** Применяет серверные ошибки валидации к полям формы (RHF-пути уже нормализованы). */
export function setServerFieldErrors<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
  fieldErrors: FieldValidationError[],
): void {
  fieldErrors.forEach(({ path, message }) => {
    setError(path as Path<TFieldValues>, { message, type: 'server' });
  });
}
